export default __webpack_public_path__ + "static/media/forest.7442a764.svg";